export const environment = {
  production: true,
  api: {
    baseUrl: 'https://api.rufflesandshinegrooming.co.uk/v1'
  }
};
